<template>
  <el-container class="hotellist-main" id="main">
    <publicHeader @setCollapse="setCollapse" @getPermissions="getPermissions"></publicHeader>
    <div style="display: flex; justify-content: flex-start;">
      <publicMenu :isCollapse="isCollapse" :allPermissions="allPermissions"></publicMenu>
      <div class="content">
        <slot>
          <el-main>
            <div class="main" ref="element" :style="{ height: `${elementHeight}px` }">
              <div style="color:#4F4C4C;">
                <!--成功 开始-->
                <div v-if="SuccessDiv" class="StatusDiv">
                  <div class="order-status-img">
                    <img src="/static/img/account/my-payment-yes.png" style="width:80px; height:80px;">
                  </div>
                  <div class="reserve-text-one">Confirmed</div>
                  <div class="reserve-text-two">Booking reference: <span style="color:#5392F9;">{{orderno}}</span></div>
                  <div class="reserve-text-two">
                    Booking confirmation will be sent to your email (<span style="color:#5392F9;">{{userEmail}}</span>) within 10 minutes.
                  </div>
                  <div style="margin: 100px 0;">
                    <el-button class="booknow_button float-none" @click="cityRouterLink">Home</el-button>
                    <el-button class="white_button" @click="lookMyBook">Review booking</el-button>
                  </div>
                </div>
                <!--成功 结束-->
                <!--失败 开始-->
                <div v-if="FailedDiv" class="StatusDiv">
                  <div class="order-status-img">
                    <img src="/static/img/account/my-error.png" style="width:80px; height:80px;">
                  </div>
                  <div class="reserve-text-one">Sold out</div>
                  <div class="fail-reserve-text-two">
                    Selected room type sold out. Please explore other available options.
                  </div>
                  <div>
                    <div style="margin: 100px 0;">
                      <router-link :to="{ name: 'HotelDetail',  query: { 'hotelid': paramsArr.hotelid, 'region': paramsArr.region, 'start_date': paramsArr.checkin, 'end_date': paramsArr.checkout, 'room': paramsArr.room, 'adult': paramsArr.adult, 'child': paramsArr.childNums} }">
                        <el-button class="booknow_button float-none">Other</el-button>
                      </router-link>
                      <el-button class="white_button" @click="cityRouterLink">Home</el-button>
                    </div>
                  </div>
                </div>
                <!--失败 结束-->
                <!--待确认 开始-->
                <div v-if="WaitConfirmationDiv" class="StatusDiv">
                  <div style="display:block;">
                    <img src="/static/img/account/waitconfirmation.png" style="width:80px; height:80px;">
                  </div>
                  <div class="reserve-text-one">
                    <div style="display:inline-block;">{{$t('pending')}}</div>
                  </div>
                  <div class="reserve-text-two">
                    Booking reference: <span style="color:#5392F9;">{{orderno}}</span>
                  </div>
                  <div class="reserve-text-two">
                    Your order is currently pending confirmation. We will confirm the status within 10 minutes.
                  </div>
                  <div class="reserve-text-two">
                    Order status notifications will also be sent to your email: <span style="color:#5392F9;">{{userEmail}}</span>
                  </div>
                  <div style="margin: 100px 0;">
                    <el-button class="booknow_button float-none" @click="cityRouterLink">Home</el-button>
                    <el-button class="white_button" @click="lookMyBook">Review booking</el-button>
                  </div>
                </div>
                <!--待确认 结束-->
              </div>
            </div>
          </el-main>
        </slot>
        <publicFooter :source="source"></publicFooter>
      </div>
    </div>
</el-container>
</template>

<script>
import { getCityId } from '@/request/hotel.js'
import { orderPayResultShow } from '@/request/order.js'
import publicFooter from '@/components/public/publicFooter'
import publicHeader from '@/components/public/publicHeader'
import publicMenu from '@/components/public/publicMenu'
export default {
  name: 'PayResult',
  components: {
    publicFooter,
    publicHeader,
    publicMenu
  },
  data () {
    return {
      currencyShow: false, // 币种是否显示
      SuccessDiv: false,
      FailedDiv: false,
      WaitConfirmationDiv: false,
      orderno: '',
      hotelid: '',
      userEmail: '',
      paramsArr: {},
      orderDetail: [],
      hotelDetail: [],
      elementHeight: document.documentElement.clientHeight,
      city: {},
      cityname: '',
      language: this.common.languageSet(this),
      // ismobile: false,
      isBackHome: true,
      isBooking: false,
      isPrint: false,
      minutes: '60',
      contentWidth: document.body.clientWidth - 74,
      isCollapse: this.common.collapseSet(),
      allPermissions: {'email': '', 'phone_internal': '', 'phone_external': ''}
    }
  },
  created () {
    // if (document.documentElement.clientWidth < 1001) {
    //   this.ismobile = true
    // } else {
    //   this.ismobile = false
    // }
    this.payResult()
    this.getCityIdFun()
  },
  watch: {
    language: function (newCur, oldCur) {
      this.payResult()
      this.getCityIdFun()
    }
  },
  methods: {
    getPermissions (value) {
      this.allPermissions = value
    },
    setCollapse (value) {
      this.isCollapse = value
      if (value === false) {
        this.contentWidth = document.body.clientWidth - 260
      } else {
        this.contentWidth = document.body.clientWidth - 74
      }
      this.personWidth = (this.contentWidth * 0.2182) - 10
    },
    hotelLanguage (language) {
      this.language = language
    },
    payResult: function () {
      let locationHref = window.document.location.href
      var params = this.$route.params
      var orderResultData = localStorage.getItem('orderResultData')
      if (JSON.stringify(params) === '{}' && orderResultData !== '{}') {
        params = JSON.parse(orderResultData)
      }
      this.paramsArr = params

      // 验证verify
      var token = this.$md5('0' + this.common.lfSignKey)
      if (localStorage.getItem('token')) {
        token = localStorage.getItem('token')
      }
      var currency = this.common.currencySet(this)
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)

      this.orderno = params.orderno
      this.hotelid = params.hotelid

      // 订单结果数据
      var orderResultJson = {
        'token': token,
        'hotelid': this.hotelid,
        'checkin': params.checkin,
        'checkout': params.checkout,
        'room': params.room,
        'adult': params.adult,
        'child': params.child,
        'childNums': params.childNums,
        'product': params.product,
        'time': time,
        'orderno': params.orderno,
        'currency': currency,
        'operation': 'orderPayResultShow'
      }
      var orderResultShow = this.common.encryptionData(orderResultJson, this)
      // 1-待支付 2-待确认 3-已确认 4-已取消 5-拒单
      orderPayResultShow(orderResultShow).then(res => {
        if (res.flag === '001') {
          sessionStorage.setItem('LoginWebsiteAddress', locationHref)
          this.$router.push({name: 'login'})
        } else if (['200'].includes(res.flag)) {
          this.orderno = res.data.orderno
          this.userEmail = res.data.email
          this.minutes = res.data.minutes
          if (['3'].includes(res.data.orderStatus)) {
            this.SuccessDiv = true
          } else if (['2'].includes(res.data.orderStatus)) {
            this.WaitConfirmationDiv = true // 待确认产品
          } else if (['5'].includes(res.data.orderStatus)) {
            this.FailedDiv = true
          }
        }

        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(orderResultShow, res, requestTime, responseTime)
        })
      })
    },
    JumpHomePage () {
      this.$router.push('WritePay')
    },
    // 获取城市ID
    getCityIdFun: function () {
      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
        if (this.language === 'zh') {
          this.cityname = this.city.chinese_name
        } else {
          this.cityname = this.city.city
        }
      })
    },
    cityRouterLink: function () {
      this.isBackHome = true
      this.isBooking = false
      this.isPrint = false
      var regionSel = {'value_en': this.city.city, 'value_zh': this.city.chinese_name, 'type_id': 1, 'type_data_id': this.city.id}
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var cityname = this.city.city
      if (this.common.languageSet(this) === 'zh') {
        cityname = this.city.chinese_name
      }
      var date1 = new Date()
      date1.setDate(date1.getDate() + 1)
      var date2 = new Date(date1)
      date2.setDate(date1.getDate() + 1)

      var month = date1.getMonth() + 1
      var monthSelect = (month) < 10 ? '0' + (month).toString() : (month).toString()
      var dateSelect = (date1.getDate()) < 10 ? '0' + (date1.getDate()).toString() : (date1.getDate()).toString()
      var startDate = (date1.getFullYear()) + '-' + monthSelect + '-' + dateSelect

      var month2 = date2.getMonth() + 1
      var monthSelect2 = (month2) < 10 ? '0' + (month2).toString() : (month2).toString()
      var dateSelect2 = (date2.getDate()) < 10 ? '0' + (date2.getDate()).toString() : (date2.getDate()).toString()
      var endDate = (date2.getFullYear()) + '-' + monthSelect2 + '-' + dateSelect2
      // var startDate = (date1.getFullYear()) + '-' + (date1.getMonth() + 1) + '-' + (date1.getDate())
      // var endDate = (date2.getFullYear()) + '-' + (date2.getMonth() + 1) + '-' + (date2.getDate())
      // 无母房型有报价
      var searchJson = {'type': 1, 'type_id': this.city.id, 'region': cityname, 'start_date': startDate, 'end_date': endDate, 'room': 1, 'adult': 2, 'child': 0}
      localStorage.setItem('searchData', JSON.stringify(searchJson))

      this.$router.push({name: 'HotelList', query: searchJson})
    },
    gotoManage () {
      this.isBackHome = false
      this.isBooking = true
      this.isPrint = false
      this.$router.push({name: 'tripDetail', query: { 'orderno': this.orderno }})
    },
    lookMyBook () {
      // 点击完成 埋点记录
      this.clickPageAction('view_book', '', {'orderno': this.orderno})

      this.$router.push({ name: 'tripDetail', query: { 'orderno': this.orderno } })
    }
  }
}
</script>

<style scoped>
.el-main {background-color: rgba(240, 242, 245, 1);color: #4F4C4C;text-align: center;line-height:35px;}
.main {width:1500px;margin: 0 auto;height:1100px;display: flex;justify-content: center;align-items: center;}
.order-status-img{width: 80px; height: 80px; margin: 0px auto 20px;}
.reserve-text-one {font-size: 22px;font-style: normal;font-weight:650;}
.reserve-text-two{font-size: 14px;}
.fail-reserve-text-two{font-size: 16px;}
.pay_button{cursor:pointer;/*width:25%;*/height:36px;font-size:14px; border:none;border-radius:4px; margin: 0px 6px;text-decoration:none;}
.pay_button:hover,.pay_button:focus{background-color:rgba(79, 76, 76, 1) !important;color: rgb(252, 210, 5) !important;border:none !important;}

.home_button{background-color:rgba(79, 76, 76, 1) !important;color: rgb(252, 210, 5) !important;}
.home_button a{color: rgb(252, 210, 5) !important;}
.travel_button{background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.travel_button a{color:#4F4C4C;}
.StatusDiv{max-width:750px;text-align: center}
.float-none {float: none !important;}
/* .travel_button a:hover{color: rgb(252, 210, 5);}
.travel_button:focus{background-color:rgba(255, 255, 255, 1);color:#4F4C4C;} */
.pay_button_fail{/*width:48%;*/height:36px;background-color:rgba(79, 76, 76, 1);color: rgb(252, 210, 5);border:none;font-size:14px; border:none;border-radius:4px; margin: 0px 6px; margin-top:10%;text-decoration:none;}
.home_button_fail{width:40%;height:36px;font-size:14px; border:none;border-radius:4px; margin-right:4%; margin-top:10%;text-decoration:none;background-color:rgba(255, 255, 255, 1);color:#4F4C4C;}
.popverText{ font-size:12px;width:20%;}
@media screen and (max-width: 1000px) {
.main {width:95%;}
.reserve-text-one{ font-size:18px;}
.pay_button, .home_button_fail{width:90%; margin-top: 10px;}
.pay_button_fail{width:90%;}
.pay_button:hover{background-color:rgba(79, 76, 76, 1) !important;color: rgb(252, 210, 5) !important;border:none !important;}
.travel_button:hover{background-color:rgba(79, 76, 76, 1);color:rgb(252, 210, 5);border:none;}
}
</style>
<style lang="scss">
/* 下载行程单 */
.score-bar{width: 100%;-webkit-box-sizing: border-box;box-sizing: border-box;}
.scoreNo{height: 6px;border-radius: 100px;background-color: rgba(79, 76, 76, 1);overflow: hidden;position: relative;vertical-align: middle;}
.scoreYes{height: 100%;text-align: right;border-radius: 100px;line-height: 1;white-space: nowrap;-webkit-transition: width .6s ease;transition: width .6s ease;background-color:rgba(252, 210, 5, 1);}
.logo-text{font-weight: 650;font-style: normal;font-size: 22px;color: #333;display: inline-block;float: right;height: 53px;line-height: 53px;width:250px;}
/* .tr td{text-align:center;} */
.information-left{width:40%;height:100%;float:left;}
.information-right{width:60%;height:100%;float:left;}
.payment-left{width:70%; float:left;}
.payment-right{width:30%; float:left;}
.policy-remarks{ background-color: rgba(221, 223, 226, 0.2980392156862745);line-height: 22px;padding: 10px 0;}
</style>



// WEBPACK FOOTER //
// src/components/order/PayResult.vue